import {
  SOP_SICKNESS_LEAVE_ABOUT_YOU_STEP,
  SOP_SICKNESS_LEAVE_PRICE_STEP,
} from "Components/Features/CheckPrice/Products/LifeProducts/SopSicknessLeave";

import { CUSTOMER_WAITING_PERIOD_BEFORE_PAYOUT_STARTS } from "Components/Features/CheckPrice/Products/LifeProducts/SopSicknessLeave/sopSicknessLeaveConstants";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";

export type SopSicknessLeaveProductBackend = {
  name: INSURANCE_NAME_VALUE;
  revenue: number;
  dailyPayoutAmount: number;
  waitingPeriodBeforePayoutStarts: number;
  dateOfBirth: string;
  coverageGroup: string;
};

export function mapToCommerceSopSicknessLeave(data: {
  [key: string]: any;
}): SopSicknessLeaveProductBackend {
  const introFormValues = data.formData[SOP_SICKNESS_LEAVE_ABOUT_YOU_STEP.id];
  const priceFormValues = data.formData[SOP_SICKNESS_LEAVE_PRICE_STEP.id];
  const { newCustomerResponse } = data.customerData;

  return {
    name: INSURANCE_NAME_VALUE.SOP_SICKNESS_LEAVE,
    revenue: introFormValues.revenue,
    dailyPayoutAmount: priceFormValues.dailyPayoutAmount,
    waitingPeriodBeforePayoutStarts:
      CUSTOMER_WAITING_PERIOD_BEFORE_PAYOUT_STARTS,
    dateOfBirth: newCustomerResponse.dateOfBirth,
    coverageGroup: priceFormValues.coverage,
  };
}
